export default {
    "title": "Home / {{client}}",
    "description": "Summary of invoices and delivery notes according to reference period",
    "descriptionWithoutInvoices": "Summary of delivery notes according to reference period",
    "descriptionWithoutDeliveryNotes": "Summary of invoices according to reference period",
    "lastYear": "Last Year",
    "currentYear": "Current Year",
    "invoices": "Invoices",
    "deliveryNotes": "Delivery notes",
    "invoicesChart": {
        "title": "Monthly invoices and total amount",
        "series": {
            "lastInvoices": "Last year invoices",
            "currentInvoices": "Current year invoices",
            "lastTotal": "Last year total amount",
            "currentTotal": "Current year total amount"
        }
    },
    "deliveryNotesChart": {
        "title": "Monthly delivery notes",
        "series": {
            "lastDeliveryNotes": "Last year",
            "currentDeliveryNotes": "Current year"
        }
    },
    "noFeaturesMessage": "Welcome to the customer extranet"
}